import { format, parseISO } from 'date-fns';

/* global CSS_CONFIG */
const timeformat = CSS_CONFIG.FORMATS.dateAndTime.time;

export const convertedTime = (
  time: string,
  isInStoreService: boolean,
): string => {
  // Back-end is sometime sending time in format `2020-10-26T11:30:00Z` instead
  // of `2020-10-26T11:30:00+00:00` when UTC. Here converting the time to this.
  const corTime = time.slice(-1) === 'Z' ? time.replace(/.$/, '+00:00') : time;

  const [availableDate, offset] =
    corTime.indexOf('+') > 0 ? corTime.split('+') : corTime.split(/-(?!.*-)/);
  const formatedAvailableDate = parseISO(availableDate);
  const [hour, minutes] = offset.split(':');

  if (minutes.indexOf('Z') > 0) {
    const minute = minutes.slice(0, -1);

    if (time.indexOf('+') > 0) {
      formatedAvailableDate.setHours(
        formatedAvailableDate.getHours() + parseInt(hour, 10),
      );
      formatedAvailableDate.setMinutes(
        formatedAvailableDate.getMinutes() + parseInt(minute, 10),
      );
    } else {
      formatedAvailableDate.setHours(
        formatedAvailableDate.getHours() - parseInt(hour, 10),
      );
      formatedAvailableDate.setMinutes(
        formatedAvailableDate.getMinutes() - parseInt(minute, 10),
      );
    }
  }

  if (isInStoreService) {
    return format(formatedAvailableDate, timeformat);
  }

  return format(parseISO(time), timeformat);
};

export const dateToCalendar = (date: string): string => {
  return format(new Date(date), 'yyyy-MM-dd');
};
